import { calmTokens as t } from '../../../shared/tokens';
import { monoStyle } from './styles';

/** Carte de section « Calm ». */
export function Card({ title, subtitle, action, children, style }) {
  return (
    <div
      style={{
        background: t.surface,
        border: `1px solid ${t.border}`,
        borderRadius: 18,
        padding: 20,
        marginBottom: 16,
        ...style,
      }}
    >
      {(title || action) && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 12,
            marginBottom: 14,
            flexWrap: 'wrap',
          }}
        >
          <div style={{ minWidth: 0 }}>
            {title && (
              <h3
                style={{
                  fontFamily: t.fontDisp,
                  fontSize: 17,
                  fontWeight: 500,
                  margin: 0,
                  letterSpacing: -0.3,
                  color: t.text,
                }}
              >
                {title}
              </h3>
            )}
            {subtitle && (
              <div style={{ fontSize: 12, color: t.textMute, marginTop: 4, lineHeight: 1.4 }}>{subtitle}</div>
            )}
          </div>
          {action && <div style={{ flexShrink: 0 }}>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
}

/** Pastille colorée (statut, action, origine). */
export function Chip({ kind, children, icon, title, style }) {
  const k = kind || { color: t.textDim, bg: 'rgba(255,255,255,0.04)', border: t.border };
  return (
    <span
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '3px 9px',
        borderRadius: 999,
        fontSize: 10.5,
        fontWeight: 500,
        color: k.color,
        background: k.bg,
        border: `1px solid ${k.border}`,
        whiteSpace: 'nowrap',
        fontFamily: t.fontUi,
        letterSpacing: -0.05,
        ...style,
      }}
    >
      {icon}
      {children}
    </span>
  );
}

/** Bouton pilule (primaire = fond clair, sinon contour). */
export function PillButton({ primary, danger, children, icon, disabled, onClick, type = 'button', small, style, title }) {
  const bg = primary ? t.text : 'transparent';
  const color = primary ? t.bg : danger ? t.debit : t.textDim;
  const border = primary ? 'none' : `1px solid ${danger ? t.debitBorder : t.border}`;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      title={title}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        padding: small ? '6px 12px' : '10px 16px',
        borderRadius: 999,
        fontSize: small ? 12 : 13,
        fontWeight: 500,
        fontFamily: t.fontUi,
        background: bg,
        color,
        border,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'opacity .15s, background .15s',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {icon}
      {children}
    </button>
  );
}

/** Petite ligne « clé · valeur » pour les résumés. */
export function Stat({ label, value, accent }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 90 }}>
      <span style={{ fontSize: 10.5, color: t.textMute, textTransform: 'uppercase', letterSpacing: 0.8 }}>{label}</span>
      <span style={{ fontSize: 18, fontWeight: 500, color: accent || t.text, ...monoStyle }}>{value}</span>
    </div>
  );
}

export function Divider() {
  return <div style={{ height: 1, background: t.border, margin: '0 -20px' }} />;
}
